import { apiSlice } from './apiSlice';
//const AGENCY_URL = '/api/agencies';
import { AGENCY_URL } from '../constants';

export const agencyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAgency: builder.mutation({
      query: (data) => ({
        url: AGENCY_URL,
        method: 'POST',
        body: data,
      }),
    }),
    updateAgency: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${AGENCY_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    getAgencies: builder.query({
      query: () => AGENCY_URL,
    }),
    getAgencyById: builder.query({
      query: (id) => `${AGENCY_URL}/${id}`,
    }),
  }),
});

export const {
  useCreateAgencyMutation,
  useUpdateAgencyMutation,
  useGetAgenciesQuery,
  useGetAgencyByIdQuery,
} = agencyApiSlice;





